angular.module('leanlaw').controller('MyProductivityCtrl', ['$scope', '$window', '$rootScope', '$filter', '$timeout', '$stateParams', '$state', "alerts", 'userService', 'reportsService', "exportJson", "singleRequest", "messageBus", function ($scope, $window, $rootScope, $filter, $timeout, $stateParams, $state, alerts, userService, reportsService, exportJson, singleRequest, messageBus) {
  $scope.clients = {};
  $scope.filter = {};
  $scope.search = "";
  $scope.format = {};
  $scope.sort = ['client.label', 'matter.label'];
  $scope.reverse = false;
  $scope.print = function () {
    window.print();
  };
  $scope.export = function () {
    const matter = $scope.me.terms.Matter;
    const exp = $scope.data.filteredClients.reduce((accum, c) => {
      const item = {};
      if ($scope.clientReferences || $scope.references) {
        item["ID"] = c.client.reference || "";
      }
      item["Client"] = c.client.name;
      if ($scope.filter.include && $scope.filter.include.matters) {
        item[matter] = "";
      }
      if ($scope.me.adjustments) {
        item["Billable Hours Worked"] = $filter("hoursDecimal")(c.data.hours.trackedHours);
        item["Billable Hours Write-down"] = $filter("hoursDecimal")(c.data.hours.writedown);
      }
      item["Billable Hours Total"] = $filter("hoursDecimal")(c.data.hours.billable);
      item["Fixed Fee Hours"] = $filter("hoursDecimal")(c.data.hours.charges);
      item["Non-billable Hours"] = $filter("hoursDecimal")(c.data.hours.nonBillable);
      item["Total Hours"] = $filter("hoursDecimal")(c.data.hours.total);
      if ($scope.me.adjustments) {
        item["Worked Hours Value"] = $filter("hoursDecimal")(c.data.amounts.trackedHours);
      }
      item["Fixed Fee Hours Value"] = $filter("amount")(c.data.amounts.chargesHours);
      item["Billable Hours Value"] = $filter("amount")(c.data.amounts.hours);
      if ($scope.me.adjustments) {
        item["Write-down"] = $filter("amount")(c.data.amounts.writedown);
      }
      item["Expenses"] = $filter("amount")(c.data.amounts.expenses);
      accum.push(item);
      if ($scope.filter.include && $scope.filter.include.matters) {
        c.matters.forEach(m => {
          const matterItem = {};
          matterItem["ID"] = m.matter.reference ? !isNaN(m.matter.reference) ? `="${m.matter.reference}"` : m.matter.reference : '';
          matterItem["Client"] = "";
          matterItem[matter] = m.matter.name;
          if ($scope.me.adjustments) {
            matterItem["Billable Hours Worked"] = $filter("hoursDecimal")(m.data.hours.trackedHours);
            matterItem["Billable Hours Write-down"] = $filter("hoursDecimal")(m.data.hours.writedown);
          }
          matterItem["Billable Hours Total"] = $filter("hoursDecimal")(m.data.hours.billable);
          matterItem["Fixed Fee Hours"] = $filter("hoursDecimal")(m.data.hours.charges);
          matterItem["Non-billable Hours"] = $filter("hoursDecimal")(m.data.hours.nonBillable);
          matterItem["Total Hours"] = $filter("hoursDecimal")(m.data.hours.total);
          if ($scope.me.adjustments) {
            matterItem["Worked Hours Value"] = $filter("hoursDecimal")(m.data.amounts.trackedHours);
          }
          matterItem["Fixed Fee Hours Value"] = $filter("amount")(m.data.amounts.chargesHours);
          matterItem["Billable Hours Value"] = $filter("amount")(m.data.amounts.hours);
          if ($scope.me.adjustments) {
            matterItem["Write-down"] = $filter("hoursDecimal")(m.data.amounts.writedown);
          }
          matterItem["Expenses"] = $filter("amount")(m.data.amounts.expenses);
          accum.push(matterItem);
        });
      }
      return accum;
    }, []);
    exportJson.downloadCsv(exp);
  };
  $scope.loading = true;
  userService.me().then(me => {
    $scope.me = me;
    $scope.title = `My Productivity`;
    $scope.trust = me.company.settings.trustEnabled;
    $scope.$on('commonFilterService-statechanged', (event, payload) => {
      if (!payload) return;
      // Assigning to existing filter keeps custom filter options
      $scope.filter = Object.assign($scope.filter, payload);
      // Necessary to set this value for the requests
      $scope.filter.status = $scope.filter.archived.status;
      $scope.filter.scope = $scope.filter.filter.scope;
      $scope.filter.billed = $scope.filter.billedFilter && $scope.filter.billedFilter.id;
      // if (payload.filter.range) filterClientEntries();

      filterClientEntries();
    });
    $scope.$on("report-sidebar-filterchange", (event, payload) => {
      $scope.filter = Object.assign($scope.filter, payload);
    });
    $scope.$on("report-clientmatter-change", (event, cm) => {
      singleRequest.cancel("clientEntries");
      $scope.goToSummary(cm.client ? cm.client.id : null, cm.matter ? cm.matter.id : null);
    });
    $scope.$watch('filter.include.accounting', show => {
      if (show) {
        filterClientEntries();
      }
    }, true);

    // MessageBus is used here so that the commonFilter module can pick it up once it loads
    messageBus.addMessage("filterDependency-ready", true);
    messageBus.addMessage("clientmatter-set", true, {});
  });
  function filterClientEntries() {
    $scope.loading = true;
    $scope.data = null;
    const query = reportsService.queryFromFilter($scope.filter);
    query.primary = 'clients';
    query.data = "services,hours,expenses";
    query.account = $scope.me.id;
    singleRequest.apiCall("my-productivity", true).getReport(query).then(data => {
      if (!data) return;
      $scope.data = data;
      $scope.data.clients.forEach(client => {
        adjustData(client);
        client.matters.forEach(adjustData);
      });
      adjustData(data);
      $scope.loading = false;
    }).catch(err => {
      alerts.error(err);
      $scope.loading = false;
    });
  }
  function adjustData(item) {
    const {
      amounts
    } = item.data;
    amounts.writedownPercent = amounts.trackedHours ? Math.round(1000 * amounts.writedown / amounts.trackedHours) / 10 : '-';
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("my-productivity");
    deactivate();
  });
  $scope.goToSummary = function (client, matter) {
    return $state.go("reports.productivity-detail", {
      ...$stateParams,
      clientId: client?.id,
      matterId: matter?.id,
      userId: $scope.me.id,
      report: `${client.label}` + (matter ? ` - ${matter.label}` : ''),
      return: "reports.my-productivity"
    });
  };
  $scope.return = function () {
    $window.history.back();
  };

  // The rows the table shows. Precomputed here rather than assigned from the
  // ng-repeat expression, which re-ran the filter and sort on every digest.
  function updateFiltered() {
    if (!$scope.data) return;
    $scope.data.filteredClients = $filter('orderBy')($filter('filter')($scope.data.clients, $scope.search), $scope.sort, $scope.reverse) || [];
    $scope.data.filteredClients.forEach(client => {
      client.filteredMatters = $filter('orderBy')($filter('filter')(client.matters, $scope.q), $scope.sort, $scope.reverse) || [];
    });
  }
  $scope.$watch('data.clients', updateFiltered);
  $scope.$watch('search', updateFiltered);
  $scope.$watchGroup(['sort', 'reverse'], updateFiltered);
}]);